var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { addOnInfo } from '@content/products/extras';
import { buildYourBoxFeaturetteContent, mealPromoContent, pdpHeroSectionContent, rtbWithIconsSectionContent, } from '@marketing/components/sections/content';
import PDPHeroSection from '@marketing/components/sections/heroes/PDP';
import Featurette from '@marketing/components/sections/non_product/Featurette';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import RTBWithIconsSection from '@marketing/components/sections/non_product/RTB/RTBWithIcons';
import MealPromo from '@marketing/components/sections/product/MealPromo';
import NutritionFactsSection from '@marketing/components/sections/product/nutrition/NutritionFacts';
import { TreatName } from '@marketing/content';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router';
import { sendGoogleTagManagerEvent } from '@trackers';
import { OUT_OF_STOCK_PRODUCT_TYPES_PROFILE } from '@variables';
var TreatsProductListing = function () {
    var treatProductId = useParams().treatProductId;
    var treatProductIdWithUnderscores = treatProductId.replace(/-/g, '_');
    var location = useLocation();
    useEffect(function () {
        sendGoogleTagManagerEvent({
            event: "view-".concat(treatProductIdWithUnderscores),
        });
    }, [location.pathname]);
    if (!Object.values(TreatName).includes(treatProductId)) {
        // handle this when we have a 404 page
        return null;
    }
    var pdpHeroContent = pdpHeroSectionContent[treatProductId];
    var rtbWithIconsContent = rtbWithIconsSectionContent[treatProductId];
    var displayName = addOnInfo[treatProductId].displayName;
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: [displayName, " Treats for Dogs | Nom Nom"] }), _jsx("meta", { name: "description", content: "Try Nom Nom's ".concat(displayName, " treats for dogs for a great way to engage your dog & add excitement between meal times.") }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/other-products/treats/".concat(treatProductId) }), _jsx("script", __assign({ type: "application/ld+json" }, { children: JSON.stringify(addOnInfo[treatProductId].seoSchemaJson) }))] }), _jsxs("div", __assign({ className: "header-lining bg-surface-beige" }, { children: [_jsx(PDPHeroSection, { content: pdpHeroContent, isOutOfStock: OUT_OF_STOCK_PRODUCT_TYPES_PROFILE.includes(treatProductId) }), _jsx(NutritionFactsSection, { type: "treat", productId: treatProductId, expandable: false }), _jsx(RTBWithIconsSection, { content: rtbWithIconsContent }), _jsx(MealPromo, { content: mealPromoContent.treatsPDP, backgroundColorStyle: "bg-surface-beige", stacked: false, pageName: "".concat(treatProductIdWithUnderscores, "_pdp") }), _jsx(Featurette, { content: buildYourBoxFeaturetteContent, flip: true, backgroundColorStyle: "bg-action-surface-primary" }), _jsx(Newsletter, {})] }), treatProductId)] }));
};
export default TreatsProductListing;
